import React from "react";
import {Dialog} from "@material-ui/core";
import warningImage from "../../../images/warning.svg"
import {ReactSVG} from "react-svg";
import {Button} from "../../../components/Button";
import {strings} from "../../../strings/strings";

interface StepInformMessageDialog {
    open: boolean;
    onClose: (event: any) => void;
    acceptClickListener: () => void;
    messages: Array<string>;
}

export const StepInformMessageDialog = (props: StepInformMessageDialog) => {
    const {open, onClose, acceptClickListener, messages} = props;

    return (
        <Dialog open={open} onClose={onClose} disableBackdropClick={true}>
            <div className={"vs-dialog vs-dialog_not-found"}>
                <div className={"vs-dialog__content fluid"}>
                    <div className={"vs-dialog__content__icon"}>
                        <ReactSVG src={warningImage}/>
                    </div>

                    <span className={"vs-dialog__content__title"}>{strings.infoMessages}</span>

                    {messages.map(message => {
                        return  <p className={"vs-dialog__content__text"}>
                                    {message}
                                </p>
                    })}

                    <div className={"vs-dialog__content__controls"}>
                        <Button id={'stepInformMessage_accept'}  label={strings.acceptButton} onClickListener={acceptClickListener}/>
                    </div>
                </div>
            </div>
        </Dialog>
    )
};